import { useState } from "react";
import { Filter, MultiFilter } from "./Filter";

export function useFilter<T>(options: T[], initialValue?: T): Filter<T> {
  const [selectedValue, setSelectedValue] = useState<T>(
    !!initialValue ? initialValue : options[0]
  );

  return {
    options,
    selectedValue,
    setSelectedValue,
    resetValue: initialValue,
  };
}

export function useMultiFilter<T>(
  options: T[],
  initialOptions?: T[]
): MultiFilter<T> {
  const [selectedValues, setSelectedValues] = useState<T[]>(
    !!initialOptions ? initialOptions : options
  );

  const tournamentFilter: MultiFilter<T> = {
    options,
    selectedValues,
    setSelectedValues,
  };

  return tournamentFilter;
}
